import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TechnicalViewService } from 'src/app/_services/technical-view.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ViewTechnicalComponent } from '../../pages/technical/view-technical/view-technical.component';
import { ViewJobComponent } from '../../pages/technical/view-job/view-job.component';
import { SignoffIssueComponent } from '../active-issues/signoff-issue/signoff-issue.component';
import { UpdateRecordComponent } from '../../pages/technical/update-record/update-record.component';
import { UpdateJobComponent } from '../../pages/technical/update-job/update-job.component';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { JobFormComponent } from '../../pages/technical/job-form/job-form.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() dataConfig: any;
  @Input() selectedVehicle: any;
  @Output() selectedRowObservable$ = new EventEmitter<any>();
  @Output() selectedRowCMObservable$: EventEmitter<any> =
    new EventEmitter<any>();
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('signedOffIssuesTable') signedOffIssuesTable: Table | undefined;
  selectedRow: any;
  selectedTechnicalRecord: any;
  menuItems: MenuItem[];
  selectedRowCM: any;
  isLoading = false;
  ref: any;
  selectedJob: any;
  totalRecords = 0;
  loading = false;
  technicalData: any[] = [];
  currentFilter = '';
  currentFirst = 0;
  currentRows = 1000;
  private reloadRecordsSubscription: Subscription | undefined;
  private currentVehicleId: string | null = null;

  columns = [
    { field: 'date_completed', header: 'Date Completed' },
    { field: 'odometer', header: 'Odometer' },
    { field: 'record_type', header: 'Record Type' },
    { field: 'description_tag', header: 'Jobs' },
  ];

  constructor(
    private technicalViewService: TechnicalViewService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    this.menuItems = [
      {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          if (this.selectedRowCM) {
            this.selectedRowCMObservable$.emit(this.selectedRowCM);
          }
        },
      },
      {
        label: 'Delete',
        icon: 'pi pi-fw pi-trash',
        command: (event) => {
          if (this.selectedRowCM) {
          }
        },
      },
    ];
  }

  loadTechnicalRecordsByVehicleRef(
    event: any = { first: this.currentFirst, rows: this.currentRows }
  ) {
    this.loading = true;
    this.isLoading = true;

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.currentRows;
    const page = Math.floor(first / rows) + 1;
    const vehicleId = this.getSelectedVehicleId();

    this.currentFirst = first;
    this.currentRows = rows;

    if (!vehicleId) {
      this.technicalData = [];
      this.totalRecords = 0;
      this.loading = false;
      this.isLoading = false;
      return;
    }

    this.technicalViewService
      .getTechnicalRecordsByVehicleId(
        vehicleId,
        page,
        rows,
        this.currentFilter
      )
      .subscribe(
        (data: any) => {
          if (vehicleId !== this.getSelectedVehicleId()) {
            return;
          }

          const responseBody = data?.body || {};

          this.totalRecords = responseBody.total_records || 0;
          this.technicalData = responseBody.records || [];
          this.technicalViewService.updateTechnicalRecords(this.technicalData);
          this.loading = false;
          this.isLoading = false;
        },
        (err) => {
          if (vehicleId !== this.getSelectedVehicleId()) {
            return;
          }

          // console.log('err', err);
          this.technicalData = [];
          this.totalRecords = 0;
          this.loading = false;
          this.isLoading = false;
        }
      );
  }

  getNumberofColumns() {
    return this.columns.length;
  }

  ngOnInit(): void {
    // console.log('data', this.data);
    // console.log('vehicle', this.selectedVehicle);

    this.reloadRecordsSubscription =
      this.technicalViewService.reloadRecords$.subscribe(() => {
        this.loadTechnicalRecordsByVehicleRef({
          first: this.currentFirst,
          rows: this.currentRows,
        });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes['selectedVehicle'] ||
      this.dataConfig?.dataType !== 'technical'
    ) {
      return;
    }

    const vehicleId = this.getSelectedVehicleId();

    if (vehicleId === this.currentVehicleId) {
      return;
    }

    this.currentVehicleId = vehicleId;
    this.currentFirst = 0;
    this.selectedRow = null;
    this.selectedTechnicalRecord = null;

    this.loadTechnicalRecordsByVehicleRef({
      first: 0,
      rows: this.currentRows,
    });
  }

  ngOnDestroy(): void {
    this.reloadRecordsSubscription?.unsubscribe();
  }

  private getSelectedVehicleId(): string | null {
    const vehicleId =
      this.selectedVehicle?.id ?? this.selectedVehicle?.vehicle_id;

    return vehicleId == null ? null : String(vehicleId);
  }

  storeRowDetail(rowData: any) {
    this.selectedVehicle = rowData;
  }

  storeJobDetail(rowData: any) {
    this.selectedJob = rowData;
  }

  storeTechnicalRecordDetail(rowData: any) {
    this.selectedTechnicalRecord = rowData;
  }

  items: MenuItem[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.showEdit(this.selectedTechnicalRecord),
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.deleteRecord(this.selectedTechnicalRecord),
    },
  ];

  jobs: MenuItem[] = [
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.showDeleteJob(this.selectedJob),
    },
  ];

  showJobEdit(job: any) {
    this.ref = this.dialogService.open(JobFormComponent, {
      header: 'Update Job',
      width: '50%',
      styleClass: 'update-record-dialog-shell',
      data: job,
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.loadTechnicalRecordsByVehicleRef({
          first: this.currentFirst,
          rows: this.currentRows,
        });
      }
    });
  }

  showDeleteJob(job: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this job?',
      header: 'Delete Job',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // console.log('record', this.selectedVehicle);
        this.technicalViewService.deleteTechnicalJob(job.id).subscribe(
          (res) => {
            this.loadTechnicalRecordsByVehicleRef({
              first: this.currentFirst,
              rows: this.currentRows,
            });
          },
          (err) => {
            // console.log('err', err);
          }
        );
      },
    });
  }

  showEdit(record: any) {
    this.ref = this.dialogService.open(UpdateRecordComponent, {
      header: 'Update Record',
      width: '70%',
      styleClass: 'update-record-dialog-shell',
      data: record,
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.loadTechnicalRecordsByVehicleRef({
          first: this.currentFirst,
          rows: this.currentRows,
        });
      }
    });
  }

  deleteRecord(record: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this record?',
      header: 'Delete Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // console.log('record', record);
        this.technicalViewService.deleteTechnicalRecord(record.id).subscribe(
          (res) => {
            this.loadTechnicalRecordsByVehicleRef({
              first: this.currentFirst,
              rows: this.currentRows,
            });
          },
          (err) => {
            // console.log('err', err);
          }
        );
      },

    });
  }

  showEditTechnicalRecordJob($event: any) {
    // console.log('row', $event);
    let row = $event;
    this.ref = this.dialogService.open(UpdateJobComponent, {
      data: row,
      header: 'Edit Job',
      width: '65%',
      height: '65%',
      styleClass: 'update-record-dialog-shell',
    });

    this.ref.onClose.subscribe((data: any) => {
      this.loadTechnicalRecordsByVehicleRef({
        first: this.currentFirst,
        rows: this.currentRows,
      });
    });
  }

  searchValue = '';

  filterGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchValue = inputElement.value.trim();
    this.currentFilter = this.searchValue;
    this.currentFirst = 0;
    this.loadTechnicalRecordsByVehicleRef({
      first: 0,
      rows: this.currentRows,
    });
  }

  clearSearch() {
    this.searchValue = '';
    this.currentFilter = '';
    this.currentFirst = 0;
    this.loadTechnicalRecordsByVehicleRef({ first: 0, rows: this.currentRows });
  }

  handleCellClick(event: Event): void {
    event.stopPropagation();
  }

  onRowSelect($event: any) {
    this.selectedRow = $event.data;
    this.selectedRowObservable$.emit($event.data);
    // console.log('selectedRow', $event);
  }

  onContextMenu($event: Event) {
    throw new Error('Method not implemented.');
  }

  openViewTechnicalRecordDialog(data: any) {
    const ref = this.dialogService.open(ViewTechnicalComponent, {
      header: 'View Technical Record',
      width: '70%',
      data: {
        technicalRecord: data,
        vehicleData: this.selectedVehicle,
      },
    });

    ref.onClose.subscribe((data) => {
      // console.log('Dialog closed', data);
    });
  }

  onJobSelect($event: any) {
    const ref = this.dialogService.open(ViewJobComponent, {
      header: 'View Job',
      width: '70%',
      data: $event,
    });
  }
}
